import { IngressEvent } from '../../../../store/_api/TypeDefs';
import { ServiceTypes } from '../TypeDefs';

export const ingressAllowsCompensate = (ingress?: IngressEvent): boolean =>
  !!ingress?.ingressConfig?.exceptionMappings?.some(
    (m) => m.actions?.some((a) => {
      const lowerAction = a.toLowerCase();
      return lowerAction === 'compensate' || lowerAction === 'compensateandrecover';
    })
  );

/**
 * @method computeIsCompensateAction
 * @description compute isCompensateAction taking into account both the service and the ingress event
 * @param designingCEM designing cem
 * @param serviceType service type
 * @param svcIsCompensateAction service isCompensateAction
 * @param ingressEvent ingress event
 */
export const computeIsCompensateAction = ({
  designingCEM,
  serviceType,
  svcIsCompensateAction,
  ingressEvent,
}: {
  designingCEM: boolean;
  serviceType?: string;
  svcIsCompensateAction?: boolean;
  ingressEvent?: IngressEvent;
}): boolean => {
  if (designingCEM || serviceType === ServiceTypes.EXTERNAL) return false;
  return !!svcIsCompensateAction && ingressAllowsCompensate(ingressEvent);
};
